module.exports = __webpack_public_path__ + "static/media/glsl.6bae1fa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/glsl.png
// module id = 87
// module chunks = 0